import { Button, Text, theme } from 'components';
import React from 'react';
import { LayoutContext, SetupBrokerageWizardModalContext } from 'contexts';
import styled from 'styled-components';
import { BannerContainer } from './constants';
import BannerAlert from './BannerAlert';

const OnboardingWizardBanner = () => {
  const { openModal } = React.useContext(SetupBrokerageWizardModalContext);
  const { isMobileView } = React.useContext(LayoutContext);
  return (
    <BannerAlert
      message={
        <BannerContainer>
          <BannerText textAlign="center" block={false} nowrap={!isMobileView}>
            Hey!
            <WaveEmoji>👋</WaveEmoji>
            Your brokerage still needs some work
            <SetupBrokerageButton
              type="link"
              onClick={openModal}
              data-cy="setup-brokerage-button"
            >
              Setup Brokerage
            </SetupBrokerageButton>
          </BannerText>
        </BannerContainer>
      }
      backgroundColor={theme.blue6}
      data-cy="onboarding-wizard-banner"
    />
  );
};

export default OnboardingWizardBanner;

const SetupBrokerageButton = styled(Button)`
  color: white;

  /*
  Overrides color change on hover, does not work well with the background
  Uses a slight opacity change instead.
  */
  &&:hover,
  &&:focus {
    color: white;
  }
  &&:hover {
    opacity: 0.8;
  }
`;

const BannerText = styled(Text)`
  color: white;
`;

const WaveEmoji = styled.div`
  display: inline-block;
  text-align: left;
  margin: 0 5px;
  height: 17px;
  min-width: 17px;
`;
